import { createFileRoute } from '@tanstack/react-router'

import { ServiceStep } from '@/pages/tablet/create-booking-page'

export const Route = createFileRoute('/_tablet-layout/branch/$id/create/_wizard/service')({
    component: ServiceStep,
})
